(function ($) {

    var $cookie = Cookies.get('accept_cookie');

    if ($cookie === undefined || $cookie == 'false') {
        $('.cookie-banner').removeClass('notice--hide');
        $('.accept-cookies-block').removeClass('hide').addClass('show');
    }else{
        $('.accept-cookies-block').removeClass('show').addClass('hide');
        $('.disable-cookies-block').removeClass('hide').addClass('show');
    }

    $('.btnAcceptCookies').on('click', function (e) {
        e.preventDefault();

        Cookies.set('accept_cookie', true, {expires: 365});

        var banner = $('.cookie-banner');

        if (banner.length === 1) {
            banner.slideUp(250, function (e) {
                $(this).remove();
            });
        }
        if ($('.btnAcceptCookies').length >= 2) {
            window.location.reload();
        }
    });

    $('.btnDisableCookies').on('click', function (e) {
        e.preventDefault();

        Cookies.set('accept_cookie', false);
        window.location.reload();
    });

})(jQuery);